import { cn as e } from "../utils/index.js";
import { Icon as t } from "./icons/icons.js";
import "./icons/index.js";
import * as n from "@radix-ui/react-accordion";
import "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/accordion.tsx
function a({ ...e }) {
	return /* @__PURE__ */ r(n.Root, {
		className: "border-b",
		"data-slot": "accordion",
		...e
	});
}
function o({ className: t, ...i }) {
	return /* @__PURE__ */ r(n.Item, {
		"data-slot": "accordion-item",
		className: e("border-b last:border-b-0", "font-normal data-[state=open]:font-medium", t),
		...i
	});
}
function s({ className: a, children: o, ...s }) {
	return /* @__PURE__ */ r(n.Header, {
		className: "flex w-full",
		children: /* @__PURE__ */ i(n.Trigger, {
			"data-slot": "accordion-trigger",
			className: e("focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>span]:rotate-180", "text-(--neutral-950) text-[20px]/[28px] items-center", a),
			...s,
			children: [/* @__PURE__ */ r("div", {
				className: "flex justify-between w-full",
				children: o
			}), /* @__PURE__ */ r(t, {
				name: "keyboard_arrow_down",
				className: "text-(--neutral-950) pointer-events-none size-6 shrink-0 translate-y-0.5 transition-transform duration-200"
			})]
		})
	});
}
function c({ className: t, children: i, ...a }) {
	return /* @__PURE__ */ r(n.Content, {
		"data-slot": "accordion-content",
		className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
		...a,
		children: /* @__PURE__ */ r("div", {
			className: e("pt-0 pb-4", t),
			children: i
		})
	});
}
//#endregion
export { a as Accordion, c as AccordionContent, o as AccordionItem, s as AccordionTrigger };
